import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';

const styles = css`
  font: inherit;
`;

export const Button = styled.button.attrs({ type: 'button' })`
  ${styles}
`;

export const InternalLink = styled(Link)`
  ${styles};
`;

export const ExternalLink = styled.a`
  ${styles};
`;
